// Jixxeo is ad-free: rewarded ads were removed. Kept as a no-op so existing games render unchanged.
export default function AdReward() {
  return null;
}
